import { Tool, ToolsApiResponse, generateMockTools } from '../types/tools';

interface ToolsApiConfig {
  baseUrl: string;
  apiKey?: string;
}

export class ToolsService {
  private config: ToolsApiConfig;
  private useMockData: boolean;

  constructor(config?: Partial<ToolsApiConfig>, useMockData = true) {
    this.config = {
      baseUrl: config?.baseUrl || '/api/tools',
      apiKey: config?.apiKey,
    };
    this.useMockData = useMockData;
  }

  async fetchTools(modelId: string): Promise<ToolsApiResponse> {
    if (this.useMockData) {
      return this.getMockTools(modelId);
    }

    try {
      const headers: HeadersInit = {
        'Content-Type': 'application/json',
      };

      if (this.config.apiKey) {
        headers['Authorization'] = `Bearer ${this.config.apiKey}`;
      }

      const response = await fetch(`${this.config.baseUrl}/${modelId}`, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch tools: ${response.statusText}`);
      }

      const data: ToolsApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching tools:', error);
      return this.getMockTools(modelId);
    }
  }

  private getMockTools(modelId: string): ToolsApiResponse {
    const tools = generateMockTools();
    return {
      tools,
      totalTools: tools.length,
      metadata: {
        modelId,
        version: '1.0.0',
        lastUpdated: new Date().toISOString(),
        language: 'en',
      },
    };
  }

  setUseMockData(useMock: boolean): void {
    this.useMockData = useMock;
  }
}

export const toolsService = new ToolsService({}, true);
export type { Tool };
